import { Workbook, Worksheet } from "exceljs";
import { ReadableWebToNodeStream } from "readable-web-to-node-stream";

export interface IExcelMapperWrapper {
	readExcel(file:File):Promise<void>;
	readCsv(file:File):Promise<void>;
	getSheet():Worksheet | null;
	hasSheet:boolean;
	removeSheet():void;
}

export function createExcelMapperWrapper():IExcelMapperWrapper{
	let sheet:Worksheet | null = null;

	return {
		async readCsv(file:File){
			let wb = new Workbook();
			let stream = new ReadableWebToNodeStream(file.stream());
			await wb.csv.read(stream, {parserOptions: {delimiter: ";"}});
			wb.title = file.name;
			sheet = wb.worksheets[0];
			this.hasSheet = true;
		},
		async readExcel(file:File){
			let wb = new Workbook();
			await wb.xlsx.read(file.stream());
			wb.title = file.name;
			sheet = wb.worksheets[0];
			this.hasSheet = true;
		},
		hasSheet: false,
		removeSheet(){
			sheet = null;
			this.hasSheet = false;
		},
		getSheet(){
			return sheet;
		}
	};
}